import { render } from "./ModifyTeam.vue?vue&type=template&id=51b1816c"
import script from "./ModifyTeam.vue?vue&type=script&lang=js"
export * from "./ModifyTeam.vue?vue&type=script&lang=js"

import exportComponent from "/home/milu/Projects/tesco-csapatnap/csapatnap.hu-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__